export default __webpack_public_path__ + "static/media/logo.fe245415.png";